import { Types } from "../actions/pensionActions";
import _ from "lodash";
import { NotificationManager } from "react-notifications";

const defaultState = {
	pensions: {
		scheme: {},
		group: {},
	},
};

const pensionReducers = (state = defaultState, action) =>{
  switch(action.type){
      case Types.PENSION_TAB: {
			let newState = _.cloneDeep(state);

			console.log("PENSION_TAB", action.tab);
			newState.pensions.tab = action.tab;

			return newState;
		}
		case Types.PENSION_SAVE_EMPLOYEES: {
			let newState = _.cloneDeep(state);

			newState.pensions.employees = action.data;

			return newState;
      }
      case Types.PENSION_SET_LETTER: {
        let newState = _.cloneDeep(state)

        console.log("PENSION_SET_LETTER", action.letter)
        newState.pensions.letter = action?.letter

        return newState
      }
      case Types.PENSION_SET_AUDIT_LOGS: {
        let newState = _.cloneDeep(state)

        console.log("PENSION_SET_AUDIT_LOGS", action?.auditLogs)
        newState.pensions.auditLogs = action?.auditLogs

        return newState
      }
    case Types.PENSION_SHOW_REASSESSMENT_MODAL: {
        let newState = _.cloneDeep(state)

        console.log("SHOW_REASSESSMENT_MODAL", action.toggleModal)
        newState.pensions.reassessmentModalStatus = action.toggleModal

        return newState
      }
    case Types.PENSION_GET_REASSESSMENT: {
        let newState = _.cloneDeep(state)

        console.log("GET_REASSESSMENT_EMPLOYEES", action.employees)
        newState.pensions.reassessmentEmployees = action.payload.agreements
        newState.pensions.reassessmentDate = action.payload.reassessmentDate

        return newState
      }
    case Types.PENSION_UPDATE_REASSESSMENT_EMPLOYEE: {
        let newState = _.cloneDeep(state)

        const index = newState.pensions.reassessmentEmployees.findIndex((e) => e.agreementId === action.agreementId)
        newState.pensions.reassessmentEmployees[index].groupId = action?.groupId

        return newState
      }
    case Types.PENSION_SET_REASSESSMENT_DATE: {
        let newState = _.cloneDeep(state)

        console.log("SET_REASSESSMENT_DATE", action.date)
        newState.pensions.reassessmentDate = action.date

        return newState
	}
		default:
			return state;
	}
};

export default pensionReducers;
